import { useState } from 'react';
import { Dialog, DialogActions, DialogBody, DialogTitle } from '../../catalyst/dialog';
import { Button } from '../../catalyst/button';
import { ClipboardDocumentIcon, CheckIcon } from '@heroicons/react/24/outline';

export function PasswordRevealDialog({
  open,
  username,
  password,
  title,
  onClose,
}: {
  open: boolean;
  username: string;
  password: string;
  title: string;
  onClose: () => void;
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        // No-op: only the explicit confirm button closes this dialog
        // so the password is never lost by an accidental dismiss.
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>
        <p className="text-sm text-zinc-700 dark:text-zinc-300 mb-3">
          Password for <span className="font-mono">{username}</span>:
        </p>
        <div className="flex items-center gap-2">
          <code className="flex-1 rounded bg-zinc-100 dark:bg-zinc-800 px-3 py-2 font-mono text-sm select-all">
            {password}
          </code>
          <Button onClick={copy} aria-label="Copy password to clipboard">
            {copied ? <CheckIcon className="size-4" /> : <ClipboardDocumentIcon className="size-4" />}
            {copied ? 'Copied' : 'Copy'}
          </Button>
        </div>
        <p className="mt-4 text-sm font-medium text-amber-700 dark:text-amber-400">
          This password will not be shown again. Copy it now and hand it to the user.
        </p>
      </DialogBody>
      <DialogActions>
        <Button color="blue" onClick={onClose}>
          I&apos;ve copied it
        </Button>
      </DialogActions>
    </Dialog>
  );
}
